import { createContext } from "react";

export const PublicConfigContext = createContext<{ supportEmail: string | null }>({
  supportEmail: null,
});
